import React from "react";
import "./About.css";

import Footer from "./Footer";
export default function About() {
  return (
    <>
      <div className="about">
        <h1>ABOUT HIN-ANIME</h1>
        <br />
        <br />
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum
          distinctio ad voluptate ratione, blanditiis excepturi culpa aliquam
          dolore mollitia sequi magni alias dolorum ab autem fugit reiciendis
          iusto, repellendus consequuntur?Lorem ipsum dolor sit amet consectetur
          adipisicing elit. Corporis natus repellat aperiam alias ratione vitae
          voluptatibus, itaque nisi ullam cumque porro earum provident pariatur
          tempore quas dolorem laborum id dolores!.. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Nostrum, sint laudantium, rem
          repellendus veniam dolorem praesentium nemo a consequatur nobis
          provident, molestiae iure esse eos. Excepturi, quia. Quisquam,
          provident culpa?Lorem, ipsum dolor sit amet consectetur adipisicing
          elit. A rerum excepturi fugiat esse similique, dicta magnam assumenda
          laborum ipsum, nesciunt corporis? Ipsam necessitatibus reiciendis nemo
          voluptas eos accusamus quisquam cupiditate.
        </p>
      </div>

      <Footer />
    </>
  );
}
